import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/useAuth';
import { isAdminRole } from '../utils/roles';
import OrgAnalyticsPanel from './OrgAnalyticsPanel';

// The leadership dashboard is now purely the admin-only, anonymized
// organization analytics view. The per-forum operational dashboard (named
// members, health radar, grow goals) lives as the "Health & Goals" tab of the
// unified /forum page, next to the roster it describes.
//
// Facilitators — who only ever saw the forum view here — are redirected to
// that tab, which also covers stale bookmarks and old /group deep links.
export default function LeadershipDashboard() {
  const { user } = useAuth();

  if (!isAdminRole(user?.role)) {
    return <Navigate to="/forum" replace />;
  }

  return <OrgAnalyticsPanel />;
}
